import { useMemo, useState } from "react";
import { ModalOrder } from "../orderModal";
import ImageLoader from "../../../../components/imageLoader";
import maskMoney from "../../../../utils/maskMoney";
import { correctDate } from "../../../../utils/formatCreatedAt";
import { correctStatus } from "../../../../utils/correctOrderStatus";

export const STATUS_COLORS = {
  waiting: "bg-yellow-500",
  production: "bg-blue-500",
  delivery: "bg-green-500",
  finished: "bg-gray-500",
  canceled: "bg-red-500",
  cancellation_requested: "bg-orange-500",
};

const OrderCard = ({ order }) => {
  const [openModal, setOpenModal] = useState(false);

  const itemsNumberText = useMemo(() => {
    const num = order.items.length;

    return `${num} ${num === 1 ? "item" : "items"}`;
  }, [order]);

  return (
    <>
      <button
        onClick={() => setOpenModal(true)}
        className="w-full flex flex-row gap-4 border-2 border-gray-200 rounded-xl p-4 hover:bg-gray-200/75 hover:border-gray-300 hover:shadow-sm transition-colors"
      >
        <div className="h-32 w-32 overflow-hidden hidden md:block rounded-lg">
          <ImageLoader
            alt={order.restaurant.fantasy_name}
            src={order.restaurant.logo}
          />
        </div>

        <div className="flex flex-1 flex-col items-start">
          <div className="flex flex-col md:flex-row items-start md:items-center md:justify-between font-bold text-xl w-full text-left">
            <span>{order.restaurant.fantasy_name}</span>

            <span className="text-primary-500">
              {maskMoney(order.order_value)}
            </span>
          </div>

          <div className="flex gap-2 text-sm text-gray-500 mt-2 md:mt-1 items-center flex-wrap">
            <span>{correctDate(order.createdAt)}</span>
            &#x2022;
            <span>{itemsNumberText}</span>
          </div>

          <span
            className={`px-3 py-1 text-sm rounded-full text-white mt-2 ${STATUS_COLORS[order.status]}`}
          >
            {correctStatus[order.status]}
          </span>

          <div className="flex-grow" />

          <span className="font-bold text-md text-gray-500 mt-2 text-left">
            Clique para ver detalhes do pedido
          </span>
        </div>
      </button>

      <ModalOrder
        close={() => setOpenModal(false)}
        open={openModal}
        data={order}
      />
    </>
  );
};

export default OrderCard;
